const CommentForm = (props: any) => {
    const { submitHandler, commentText, setCommentText, setIsEditing } = props;
    return (
        <form
            onSubmit={submitHandler}
            style={{
                margin: '4px 8px',
                borderRadius: '8px',
                boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                padding: '8px 4px 2px 4px'
            }}
        >
            <input
                className="form-control"
                type="text"
                autoFocus
                placeholder="Edit comment"
                name="text"
                value={commentText}
                onChange={(e) => setCommentText(e.target.value)}
            />
            <div className="d-flex align-items-center justify-content-end my-2">
                <span>
                    <button
                        type="submit"
                        style={{ color: 'green', background: 'none', border: 'none' }}
                    >
                        Update
                    </button>
                    <button
                        onClick={() => setIsEditing(false)}
                        style={{ background: 'none', border: 'none', color: '#1f90e0' }}
                    >
                        Cancel
                    </button>
                </span>
            </div>
        </form>
    );
};

export default CommentForm;